<template>
  <div class="blog-filters--wrap d-flex flex-wrap">
    <v-text-field
      v-model="searchTerm"
      clearable
      hide-details
      variant="outlined"
      density="comfortable"
      prepend-inner-icon="$search"
      placeholder="Suche"
      class="search-input mx-2 mb-4"
    />

    <v-select
      v-model="filters"
      :items="tags"
      item-title="label"
      item-value="id"
      clearable
      multiple
      hide-details
      variant="outlined"
      density="comfortable"
      prepend-inner-icon="$filter"
      class="filter-select mx-2 mb-4"
      placeholder="Filter"
    >
      <template #selection="{ item }">
        <v-chip
          :text="item.raw.label"
          :color="item.raw.color"
          variant="elevated"
          elevation="0"
          size="small"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'blog-filters',

  props: {
    tags: {
      type: Array,
      default: () => ([]),
    },

    activeTagFilters: {
      type: Array,
      default: () => ([]),
    },

    search: {
      type: String,
      default: '',
    },
  },

  emits: [
    'update:activeTagFilters',
    'update:search',
  ],

  computed: {
    filters: {
      get () {
        return this.activeTagFilters
      },
      set (value) {
        this.$emit('update:activeTagFilters', value)
      }
    },

    searchTerm: {
      get () {
        return this.search
      },
      set (value) {
        this.$emit('update:search', value)
      }
    },
  },
}
</script>

<style lang="scss">
  .blog-filters--wrap {
    .filter-select,
    .search-input {
      width: 300px;
      max-width: 100%;
    }
  }
</style>
